import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "agencybillingPageView"
}
const _hoisted_2 = { class: "pageConetent" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Details of ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back to Listing ")
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Agency: ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Contact Person: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Email: ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Phone: ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Address: ", -1)
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Credits Remaining ")
const _hoisted_15 = { class: "cCount" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Add Credit ")
const _hoisted_17 = { class: "tableSec" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "User Lists")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "spinners"
}
const _hoisted_20 = { class: "UserformContent" }
const _hoisted_21 = { class: "overflowDiv" }
const _hoisted_22 = { class: "footersec" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.agencyDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, [
              _hoisted_4,
              _createElementVNode("span", null, _toDisplayString(_ctx.agencyDetails.agency_name), 1)
            ]),
            _createVNode(_component_a_button, {
              class: "back-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToListing()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeftOutlined),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, [
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.agencyDetails.agency_name), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_9,
                _createTextVNode(_toDisplayString(_ctx.agencyDetails.contact_person), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_10,
                _createTextVNode(_toDisplayString(_ctx.agencyDetails.contact_email), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_11,
                _createTextVNode(_toDisplayString(_ctx.agencyDetails.contact_phone ? _ctx.agencyDetails.contact_phone : '---'), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_12,
                _createTextVNode(_toDisplayString(_ctx.agencyDetails.formatted_address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.agencyDetails.agency_credits != null ? _ctx.agencyDetails.agency_credits: 0), 1),
              _createVNode(_component_a_button, {
                type: "primary",
                block: "",
                class: "add-credit-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCredit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_a_table, {
            columns: _ctx.userColumns,
            "data-source": _ctx.userLists,
            class: "",
            rowKey: "id",
            pagination: false,
            rowClassName: 
          (record, index) => (record.status == 'active' ? 'active' : 'inactive')
        
          }, {
            status: _withCtx(({ record }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["status", record.status === 'inactive' ? 'Disabled' : ''])
              }, _toDisplayString(record.status), 3)
            ]),
            _: 1
          }, 8, ["columns", "data-source", "rowClassName"])
        ]),
        (_ctx.pageLoder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_a_spin)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_modal, {
          width: "600px",
          class: "candidate-dashboard-modal userPmodal",
          title: "Add Credits",
          visible: _ctx.createCreditVisible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createCreditVisible) = $event)),
          "cancel-button-props": { style: 'display:none' },
          "ok-button-props": { style: 'display:none' },
          maskClosable: false,
          destroyOnClose: true,
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_a_form, {
                ref: "creditFormRef",
                model: _ctx.creditFormModal,
                rules: _ctx.creditFormRules,
                colon: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, {
                      label: "Credits",
                      required: "",
                      name: "credits"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.creditFormModal.credits,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.creditFormModal.credits) = $event)),
                          type: "number",
                          placeholder: "",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_button, {
                      class: "cancel",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelCreditModal()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      class: "add",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewCredit(_ctx.creditFormModal))),
                      loading: _ctx.confirmLoading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}